(function (Drupal, $, once) {
  Drupal.behaviors.guideline_switcher = {
    attach: function (context) {
      $(function() {
        function hexToRgb(hex, op) {
          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})|([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(
            hex
          );
          return result
            ? {
                r: parseInt(hex.length <= 4 ? result[4] + result[4] : result[1], 16),
                g: parseInt(hex.length <= 4 ? result[5] + result[5] : result[2], 16),
                b: parseInt(hex.length <= 4 ? result[6] + result[6] : result[3], 16),
                toString: function () {
                  var arr = [];
                  arr.push(this.r);
                  arr.push(this.g);
                  arr.push(this.b);
                  return "rgb(" + arr.join(",") + "," + op + ")";
                },
              }
            : null;
        }

        function lightOrDark(color) {
          if (color.match(/^rgb/)) {
            color = color.match(
              /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
            );
            var r = color[1];
            var g = color[2];
            var b = color[3];
          } else {
            color = +(
              "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
            );
            var r = color >> 16;
            var g = (color >> 8) & 255;
            var b = color & 255;
          }
          var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
          if (hsp > 200) {
            return "light";
          } else {
            return "dark";
          }
        }

        var primaryColor = getComputedStyle(document.body).getPropertyValue(
          "--primary-color"
        );
        primaryColor = primaryColor.toString();
        primaryColor = primaryColor.substring(1);

        document.documentElement.style.setProperty(
          "--primary-color-light",
          hexToRgb(primaryColor, "0.1")
        );
        document.documentElement.style.setProperty(
          "--primary-color-lighter",
          hexToRgb(primaryColor, "0.05")
        );

        once('guideline-switcher-item', $('.guideline-switcher__item')).forEach(function (element, index) {

          //generating light secondary colors
          var color = getComputedStyle(document.body).getPropertyValue(
            "--color-"+(index+1)+"-1"
          );

          color = color.toString();
          color = color.substring(1);

          if (lightOrDark(color) == 'light') {
            $(element).addClass('light');

            if ($(element).hasClass('is-active')) {
              $('.guideline-switcher__title').addClass('light');
            }
          }

          document.documentElement.style.setProperty(
            "--color-"+(index+1)+"-light",
            hexToRgb(color, "0.1")
          );
          document.documentElement.style.setProperty(
            "--color-"+(index+1)+"-lighter",
            hexToRgb(color, "0.05")
          );
        });

        once('guideline-switcher-controls', $('.guideline-switcher__controls')).forEach(function (element) {
          $(element).on('click', function () {
            var $this = $(this);
            var parent = $this.closest('.guideline-switcher__wrapper');
            $this.children().toggle();
            parent.toggleClass('is-open');
            parent.children('.guideline-switcher__content').stop().slideToggle(300);
            $('#block-msfmg-book-navigation').stop().slideToggle(300);
          });
        });

        //open if parameter is present

        var getUrlParameter = function getUrlParameter(sParam) {
          var sPageURL = window.location.search.substring(1),
              sURLVariables = sPageURL.split('&'),
              sParameterName,
              i;

          for (i = 0; i < sURLVariables.length; i++) {
              sParameterName = sURLVariables[i].split('=');

              if (sParameterName[0] === sParam) {
                  return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
              }
          }
          return false;
      };

        if(getUrlParameter("sidebar-open")=="1") {
          var switcher = $('.guideline-switcher__wrapper');
          once('switcher-ready', switcher).forEach(function (element) {
            $('.guideline-switcher__controls').children().toggle();
            $(element).toggleClass('is-open');
            $(element).children('.guideline-switcher__content').stop().slideToggle(300);
            $('#block-msfmg-book-navigation').stop().slideUp(300);
          });
        }

        //downloading PDF on mobile app
        if (window.navigator.userAgent.includes('MSF/webview')) {
          $('.field--name-field-pdf-version .file--application-pdf').hide();
        }

      });
    }
  }
})(Drupal, jQuery, once);
